/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventTaskConfig } from './eventTaskConfig';

export type TaskUpdateRequestEventConfig = EventTaskConfig | null;
